import React, { useContext, useState } from 'react'
import SuperAdminContext from '../../../hooks/SuperAdminContext';
import { GoOrganization } from "react-icons/go";
import { SiAwsorganizations } from "react-icons/si";
import CardWithImage from '../../../components/Cards/CardWithImage';
import { FaDownload } from 'react-icons/fa';
import axiosInstance from '../../../services/api/axiosInstance';

const PartnerDetailedView = () => {
  const {
    partnerGlow, partnerFullDetails,
    selectedPartnerLoading, partnerApplyFilterLoading,
    selectedPartnerAds,
    smallDevice
  } = useContext(SuperAdminContext);

  const dummyLearing = [1, 2];

  const [modalLoading, setModalLoading] = useState(false);
  const [modalApiContent, setModalApiContent] = useState([]);

  const getModalData = async (modalId) => {
    let params = {
      id: modalId,
    };

    try {
      setModalLoading(true)
      const response = await axiosInstance.post("/get_detailed_description_learning", params)
      setModalLoading(false)
      if (response.data.error_code === 0) {
        setModalApiContent(response.data.data.length > 0 ? response.data.data[0].detailed_description : "");
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className='col h-100 overflow-scroll'>
      {
        partnerGlow || selectedPartnerLoading || partnerApplyFilterLoading ?
          <>
            <div className="card h-100 border-0">
              <div className="card-body h-100 overflow-scroll p-0 p-lg-3">
                <div className="container-fluid">
                  <div className="row border-bottom border-secondary border-1 py-4">
                    <div className="col-2 text-center">
                      <img
                        src={""}
                        alt="..."
                        width={100}
                        height={100}
                        className="pe-none placeholder rounded-circle"
                      />
                    </div>

                    <div className="col-10">
                      <div className="row">
                        <div className="col-lg-6 col-xxl-8">
                          <h2 className="employer-card-candidate-name mb-0 d-inline-block pe-3 border-end border-dark placeholder w-50 py-4 rounded-1 me-2"></h2>
                        </div>
                        <div className="col-12 gy-3">
                          <div className="col-6 mb-1">
                            <p className="employer-card-candidate-role placeholder py-3 mb-0 w-100 rounded-1"></p>
                          </div>

                          <div className="col-6 mb-1">
                            <p className="employer-card-candidate-role placeholder py-3 mb-0 w-100 rounded-1"></p>
                          </div>

                          <div className="col-6 mb-1">
                            <p className="employer-card-candidate-role placeholder py-3 mb-0 w-100 rounded-1"></p>
                          </div>

                          <div className="col-6 mb-1">
                            <p className="employer-card-candidate-role placeholder py-3 mb-0 w-100 rounded-1"></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 mt-3">
                    <h1 className='employer-card-candidate-name placeholder rounded-2 col-4 py-4'></h1>
                  </div>

                  <div className="py-4 pt-2">
                    <div className='d-flex flex-wrap justify-content-between col-12'>
                      <p className="job-description placeholder col-12 skeleton-jobParagraph-medium mb-3 rounded"></p>
                      <h5 className="job-title-weight placeholder rounded col-4 py-3"></h5>
                      <h5 className="job-title-weight placeholder rounded col-4 py-3"></h5>
                    </div>

                    {/* learning placeholder  */}
                    <div className="row">
                      {
                        dummyLearing.map((value, ind) => {
                          return <div className="col-12 col-md-6 p-2" key={ind}>
                            <div
                              className="card border-0 p-0 rounded-3 overflow-hidden placeholder-glow"
                              aria-hidden="true"
                            >
                              <div className="col-12 p-3">
                                <span className="placeholder col-12 py-4 rounded-top"></span>
                                <span className="placeholder col-12 py-4"></span>
                                <span className="placeholder col-12 py-4"></span>
                                <span className="placeholder col-12 py-4 rounded-bottom"></span>
                              </div>
                              <div className="card-body p-0">
                                <div className="p-3 py-4">
                                  <h5 className="card-title ">
                                    <span className="placeholder col-6 py-3 rounded-3"></span>
                                  </h5>
                                  <span className="placeholder col-3 py-2 rounded"></span>
                                  <p className="card-text">
                                    <span className="placeholder col-12 py-2 rounded "></span>
                                    <span className="placeholder col-12 py-2 rounded"></span>
                                    <span className="placeholder col-12 py-2 rounded"></span>
                                    <span className="placeholder col-8 py-2 rounded"></span>
                                  </p>
                                </div>
                                <div className="card-footer d-flex justify-content-between">
                                  <button className="btn btn-outline-secondary placeholder col-5"></button>
                                  <button className="btn btn-outline-secondary placeholder col-5"></button>
                                </div>
                              </div>
                            </div>
                          </div>
                        })
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
          :
          <>
            {
              partnerFullDetails.length ?
                <div className="card h-100 border-0">
                  <div className="card-body h-100 overflow-scroll p-0 p-lg-3">
                    <div className="container-fluid pb-5">
                      <div className="row border-bottom border-secondary border-1 py-4">
                        <div className="col-12 col-sm-3 col-xl-2 text-center">
                          <img
                            src={`${process.env.REACT_APP_SECOND_CAREERS_CDN}${partnerFullDetails[0].profile_image}`}
                            alt=""
                            width={100}
                            height={100}
                            className="rounded-circle"
                          />
                        </div>

                        <div className="col-12 col-sm-9 col-xl-10 pt-4 pt-sm-0 ">
                          <div className="container">
                            <div className="d-flex flex-wrap align-items-center h-100 col-12">
                              <div className={window.location.pathname === "/employer_dashboard/candidates/full_details"
                                ? "col-12 col-md-6  d-flex flex-wrap align-items-center text-center text-md-start"
                                : "col-lg-12  d-flex flex-wrap align-items-center"
                              }>
                                <h1 className="employer-card-candidate-name mb-0 d-inline-block pe-3 w-100">

                                  <span className="border-end border-dark pe-3">
                                    {partnerFullDetails[0].company_name}
                                  </span>

                                  <span className="employer-card-candidate-role mb-0 d-inline-block ps-3 ">
                                    {partnerFullDetails[0].partner_type}
                                  </span>
                                </h1>
                              </div>

                              {partnerFullDetails[0].city !== "" ?
                                <div className="col-12 col-sm-8 col-md-12 row justify-content-evenly mt-3">
                                  <p className={window.location.pathname === "/employer_dashboard/candidates/full_details" ?
                                    "col-12 employer-card-candidate-role text-break mb-0"
                                    :
                                    "col-12 employer-card-candidate-role mb-0"}>
                                    <strong className='pe-0'>Location :</strong>
                                    <span className='ps-2'>{partnerFullDetails[0].city},{partnerFullDetails[0].country}</span>
                                  </p>
                                </div>
                                :
                                null
                              }

                              {partnerFullDetails[0].contact_number !== "" ?
                                <div className="col-12 col-sm-8 col-md-12 row justify-content-evenly mt-3">
                                  <p className={window.location.pathname === "/employer_dashboard/candidates/full_details" ?
                                    "col-12 employer-card-candidate-role text-break"
                                    :
                                    "col-12 employer-card-candidate-role"}>
                                    <strong className='pe-0'>Contact number :</strong>
                                    <span className='ps-2'>{partnerFullDetails[0].contact_number}</span>
                                  </p>
                                </div>
                                :
                                null
                              }

                              {partnerFullDetails[0].email_id !== "" ?
                                <div className="col-12 col-sm-8 col-md-12 row justify-content-evenly">
                                  <p className={window.location.pathname === "/employer_dashboard/candidates/full_details" ?
                                    "col-12 employer-card-candidate-role text-break"
                                    :
                                    "col-12 employer-card-candidate-role"}>
                                    <strong className='pe-0'>Email id :</strong>
                                    <span className='ps-2'>{partnerFullDetails[0].email_id}</span>
                                  </p>
                                </div>
                                :
                                null
                              }

                              {partnerFullDetails[0].website_url !== "" ?
                                <div className="col-12 col-sm-8 col-md-12 row justify-content-evenly ">
                                  <p className={window.location.pathname === "/employer_dashboard/candidates/full_details" ?
                                    "col-12 employer-card-candidate-role text-break"
                                    :
                                    "col-12 employer-card-candidate-role"}>
                                    <strong className='pe-0'>Website Url :</strong>
                                    <span className='ps-2'>{partnerFullDetails[0].website_url}</span>
                                  </p>
                                </div>
                                :
                                null
                              }
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="py-4">
                        <div>
                          <h5 className="job-title-weight">About Company</h5>
                          <p className="job-description">{partnerFullDetails[0].company_description}</p>
                        </div>
                        <div className="d-flex justify-content-around mt-4">
                          <label className="company-details-icon ">
                            <GoOrganization className="me-2 text-success" />
                            {partnerFullDetails[0].partner_type}
                          </label>
                          <label className="company-details-icon">
                            <SiAwsorganizations className="me-2 text-warning" />
                            {partnerFullDetails[0].sector}
                          </label>
                        </div>
                      </div>


                      <div className={`row ${smallDevice ? "justify-content-center" : ""}`}>
                        {selectedPartnerAds.length ?
                          selectedPartnerAds.map((partnerCard, partnerCatdIndex) => {
                            return <div className="col-11 col-sm-10 col-md-6 col-lg-10 col-xl-6 p-2" key={partnerCatdIndex}>
                              <CardWithImage
                                cardImage={partnerCard.image}
                                cardTitle={partnerCard.title}
                                postedDate={partnerCard.created_at}
                                // id={partnerCard.partner_id}
                                cardTitleStyle="learningTitle"
                                imageClassName="rounded-3 img-fluid learning-img-height w-100"
                                cardText={partnerCard.detailed_description}
                                cardKey={partnerCatdIndex}
                                cardParaTestId="professionalTestId"
                                cardButtonTestId="cardButton"
                                role="learning"
                                firstButton_Name="Download"
                                secondButton_Name="Learn&nbsp;more"
                                icon={<FaDownload className="me-2" />}
                                firstCardColor="outline-secondary"
                                secondCardColor="brand-color"
                                modalContent={modalApiContent}
                                leftLearnUrl={partnerCard.attached_file}
                                rightLearnUrl={partnerCard.url}
                                getModalData={getModalData}
                                modalId={partnerCard.id}
                                modalLoading={modalLoading}
                                dataFrom="superadmin"
                                viewedCount={partnerCard?.view_count}
                              />
                            </div>
                          })
                          :
                          <div className="h-100 w-100 row align-items-center no-adds-found-height">
                            <p className='text-center'>No Ads Found</p>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                :
                <div className="h-100 w-100 row align-items-center">
                  <p className='text-center'>No Data Found</p>
                </div>
            }
          </>
      }
    </div>
  )
}

export default PartnerDetailedView